import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

/**
 * Schema do step "Tipo e Fabricante" do CreateSensorView.
 * Usado com VeeValidate para feedback instantâneo.
 */
const StepBasicInfoSchema = yup.object().shape({
  sensor_type: yup
    .object()
    .nullable()
    .required(t('errors.required', { label: t('sensors.fields.sensor_type', 'Tipo de Sensor') })),
  manufacturer: yup
    .object()
    .nullable()
    .required(t('errors.required', { label: t('sensors.fields.manufacturer', 'Fabricante') })),
})

export default StepBasicInfoSchema
